
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * LoginType enum
 */
class LoginType {
  /**
   * Initialize enum with a given value
   * @param {LoginType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof LoginType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!LoginType}
   * @param {!LoginType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof LoginType)) {
      throw new TypeError('Instance of LoginType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!LoginType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!LoginType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === LoginType.TRADING_PLATFORM.value) {
      return 'TRADING_PLATFORM'
    }
    if (this.value === LoginType.MEMBERS_AREA.value) {
      return 'MEMBERS_AREA'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!LoginType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!LoginType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!LoginType} Created enum
   */
  static fromObject (other) {
    return new LoginType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
LoginType.TRADING_PLATFORM = new LoginType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
LoginType.MEMBERS_AREA = new LoginType(0 + 1)

export { LoginType };

/**
 * Fast Binary Encoding LoginType field model
 */
class FieldModelLoginType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelLoginType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelLoginType}
   * @param {LoginType=} defaults Default value, defaults is new LoginType()
   * @returns {!LoginType} Result value
   */
  get (defaults = new LoginType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new LoginType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelLoginType}
   * @param {!LoginType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelLoginType };
